<template>
    <div>
        <v-row no-gutters>
            <v-col>
                <video id="video" ref="videoRef" autoplay></video>
            </v-col>
        </v-row>

        <v-row no-gutters>
            <v-col>
                <div id="output">{{ outputMessage }}</div>
            </v-col>
        </v-row>
        <v-row no-gutters v-if="errorMessage">
            <v-col>
                <div class="error-message">{{ errorMessage }}</div>
            </v-col>
        </v-row>
    </div>
</template>

<script setup>
import { onBeforeUnmount, onMounted, ref } from "vue";
import router from "../../router";
import requests from "../../requests";

const emit = defineEmits(["decode"]);
const outputMessage = ref("Scansiona un codice a barre...");
const errorMessage = ref("");
const videoRef = ref(null);
let video = null;
let stream = null;
onMounted(() => {
    if ("BarcodeDetector" in window) {
        video = videoRef.value;
        // Funzione per avviare lo streaming video
        async function startVideoStream() {
            try {
                stream = await navigator.mediaDevices.getUserMedia({
                    video: { facingMode: "environment" },
                });
                video.srcObject = stream;
                video.play();
                detectBarcodes();
            } catch (error) {
                console.error("Errore nell'avviare lo streaming video:", error);
                outputMessage.value =
                    "Errore: Impossibile accedere alla videocamera.";
            }
        }

        // Funzione per rilevare i codici a barre
        async function detectBarcodes() {
            const barcodeDetector = new BarcodeDetector({
                formats: ["code_128", "ean_13", "qr_code"],
            });

            // Loop per eseguire il rilevamento continuamente
            async function scanFrame() {
                try {
                    const barcodes = await barcodeDetector.detect(video);

                    if (barcodes.length > 0) {
                        outputMessage.value = `Codice rilevato: ${barcodes[0].rawValue}`;
                        console.log("Codici rilevati:", barcodes);
                        onBarcodeDecoded(barcodes[0].rawValue);
                    } else {
                        outputMessage.value = "Nessun codice rilevato.";
                    }
                } catch (error) {
                    console.error("Errore durante la rilevazione:", error);
                }

                // Continua a rilevare il frame successivo
                requestAnimationFrame(scanFrame);
            }

            scanFrame();
        }

        // Avvia il processo
        startVideoStream();
    } else {
        outputMessage.value =
            "BarcodeDetector API non supportata in questo browser.";
        console.error("BarcodeDetector API non supportata in questo browser.");
    }

    function onBarcodeDecoded(decodedString) {
        console.log(decodedString);
        requests.searchProductByBarcode(decodedString).then((response) => {
            if (response.response.status == 404)
                errorMessage.value =
                    "Articolo " + decodedString + " non trovato!";
            else {
                emit("decode", decodedString);
                router.push({
                    name: "product",
                    query: { id: response.data.cod_articolo, fromBarcode: 1 },
                });
            }
        });
    }
});
onBeforeUnmount(() => {
    stopVideoStream();
});

function stopVideoStream() {
    if (stream) {
        // Interrompi tutti i flussi attivi
        stream.getTracks().forEach((track) => track.stop());
        video.srcObject = null; // Rimuove la sorgente del video
        console.log("Videocamera spenta.");
    }
}
</script>
<style lang="scss">
video {
    width: 100%;
    max-width: 600px;
    border: 1px solid #ccc;
    margin: 10px auto;
    display: block;
}
#output {
    font-size: 18px;
    margin: 20px;
    text-align: center;
}

.error-message {
    color: red;
    margin: 20px;
    text-align: center;
}
</style>
